import React from 'react';

/* v8 Path M — EmptyState
   Shared "there's nothing here yet" placeholder. Replaces the silent
   blank screens when sub-views land on empty content (no cmp mode
   active, no simulated transactions, no custom recurring, etc.).

   Always gives the user:
   - An icon (purely decorative, glyph)
   - A heading ("No X yet")
   - Body copy explaining what this section would show when populated
   - Zero or more call-to-action buttons (navigate to settings,
     open modal, etc.)
*/
export default function EmptyState({
  icon = '·',
  heading,
  body,
  actions = [],
  className = '',
}) {
  return (
    <div
      className={`flex flex-col items-center justify-center gap-[0.6rem] py-[2rem] px-[1rem] text-center bg-white/[0.015] border border-dashed border-border rounded-md ${className}`}
    >
      <span className="text-[2rem] text-text-dim leading-none" aria-hidden>{icon}</span>
      {heading && <strong className="text-[0.92rem] text-text">{heading}</strong>}
      {body && (
        <p className="text-[0.8rem] text-text-muted max-w-[520px] leading-[1.55] m-0">
          {body}
        </p>
      )}
      {actions.length > 0 && (
        <div className="flex gap-2 flex-wrap justify-center mt-[0.4rem]">
          {actions.map((a, i) => (
            <button
              key={i}
              type="button"
              onClick={a.onClick}
              className="bg-[rgba(240,180,41,0.08)] border border-accent-gold/60 text-accent-gold px-[0.7rem] py-[0.35rem] rounded-sm cursor-pointer text-[0.78rem] font-[inherit] hover:bg-[rgba(240,180,41,0.15)]"
            >
              {a.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
